import { Box } from '@mui/material';

import ReceiptDetailsTitleSection from '@/widgets/BecomeAMember/components/Receipt/components/common/ReceiptDetailsTitleSection/ReceiptDetailsTitleSection';
import { formatDate } from '../../../../utils/formatDate';
import { Languages } from '@/common/utils/constants';

interface TermInformationProps {
  translations: Record<string, string>;
  startDate: Date;
  durationPeriod: string;
  lang: Languages;
}

export default function TermInformation({
  translations,
  startDate,
  durationPeriod,
  lang,
}: TermInformationProps) {
  const formatedStartDate = formatDate(startDate, lang);
  return (
    <Box>
      <ReceiptDetailsTitleSection
        title={`${translations['becomeamember.floatingreceipt.duration']}: ${durationPeriod}`}
      />
      <ReceiptDetailsTitleSection
        title={`${translations['becomeamember.floatingreceipt.start']}: ${formatedStartDate}`}
      />
    </Box>
  );
}
